import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { getCanonicalUrl } from 'utils/url-query';

const ProductPageSeo = ({
  title = 'CREOATE - Wholesale for Independents',
  imageUrl = 'https://app.staging.creoate-tech.com/_next/image?url=%2Fassets%2Fimages%2Flogo%2Ffull.png&w=384&q=75',
  price = '0',
  url = 'https://www.creoate.com',
  modifiedTime = '2021-07-25T18:36:28.000Z',
  Brand = 'CREOATE',
  description = 'Dream Hyaluronic Acid Serum 3% -720ml',
  id = '1',
}) => {
  const seoTitle = `${title} | CREOATE`;
  const SeoDescription = `Shop ${title} wholesale on CREOATE. 60-day returns, fast global shipping, & low order minimum`;
  const canonical = getCanonicalUrl(url);
  const poundPrice = price / 100;
  const ProductJsonLd = {
    '@context': 'http://schema.org/',
    '@id': id,
    '@type': 'Product',
    name: title,
    image: imageUrl,
    description,
    brand: {
      '@type': 'Brand',
      name: Brand,
    },
    sku: id,
    offers: {
      '@type': 'Offer',
      url,
      priceCurrency: 'GBP',
      price: poundPrice,
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
    },
  };

  const SpeakableSpecificationJsonLd = {
    '@context': 'https://schema.org/',
    '@type': 'Article',
    name: title,
    speakable: {
      '@type': 'SpeakableSpecification',
      xPath: ['/html/head/title', "/html/head/meta[@name='description']/@content"],
    },
    url,
  };

  return (
    <>
      <Head>
        <title>{seoTitle}</title>
        <meta name="description" content={SeoDescription} />
        <meta property="og:locale" content="en_GB" />
        <meta property="og:type" content="product" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={SeoDescription} />
        <meta property="og:url" content={url} />
        <meta property="og:site_name" content="CREOATE" />
        <meta property="article:modified_time" content={modifiedTime} />
        <meta property="og:image" content={imageUrl} />
        <meta property="og:image:width" content="1368" />
        <meta property="og:image:height" content="1824" />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={SeoDescription} />
        <meta name="twitter:site" content="@creoateuk" />
        <meta name="twitter:creator" content="@creoateuk" />

        <link rel="canonical" href={canonical} />

        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      </Head>

      <script
        id="seo-script-product-SpeakableSpecification"
        type="application/ld+json"
        data-turbolinks-track="reload"
        dangerouslySetInnerHTML={{
          __html: JSON?.stringify(SpeakableSpecificationJsonLd),
        }}
      />

      <script
        id="seo-script-Product"
        type="application/ld+json"
        data-turbolinks-track="reload"
        dangerouslySetInnerHTML={{ __html: JSON?.stringify(ProductJsonLd) }}
      />
    </>
  );
};

ProductPageSeo.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  price: PropTypes.number,
  description: PropTypes.string,
  url: PropTypes.string,
  modifiedTime: PropTypes.string,
  Brand: PropTypes.string,
  id: PropTypes.string,
};

export default ProductPageSeo;
